import React, { useEffect, useState, useRef } from 'react';
import { Header } from './components/Header';
import { Description } from './components/Description';
import { TypeAdvantages } from './components/TypeAdvantages';
import { NewsUpdates } from './components/NewsUpdates';
import { Fanspace } from './components/Fanspace';
import { YouTubeChannels } from './components/YouTubeChannels';
import { AnimatedBackground } from './components/AnimatedBackground';
import { ThemeProvider } from './components/ThemeContext';
import { ThemeToggle } from './components/ThemeToggle';
import { Pokedex } from './components/Pokedex';
import { GuessThatPokemon } from './components/GuessThatPokemon';
import { Shop } from './components/Shop';
import { Wardrobe } from './components/Wardrobe';
import { PokePoints } from './components/PokePoints';
export function App() {
  const [activeSection, setActiveSection] = useState('description');
  const [isPokedexVisible, setIsPokedexVisible] = useState(true);
  const [pokePoints, setPokePoints] = useState(0);
  // Load saved PokePoints on component mount
  useEffect(() => {
    const savedPoints = localStorage.getItem('pokePoints');
    if (savedPoints) {
      setPokePoints(parseInt(savedPoints, 10));
    }
  }, []);
  // Update pokePoints whenever localStorage changes
  useEffect(() => {
    const handleStorageChange = () => {
      const savedPoints = localStorage.getItem('pokePoints');
      if (savedPoints) {
        setPokePoints(parseInt(savedPoints, 10));
      }
    };
    // Listen for storage events (when localStorage changes in other components)
    window.addEventListener('storage', handleStorageChange);
    // Poll for changes every second (as a fallback)
    const interval = setInterval(() => {
      const savedPoints = localStorage.getItem('pokePoints');
      if (savedPoints && parseInt(savedPoints, 10) !== pokePoints) {
        setPokePoints(parseInt(savedPoints, 10));
      }
    }, 1000);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [pokePoints]);
  const handlePurchase = (cost, stickerId) => {
    const newPokePoints = pokePoints - cost;
    setPokePoints(newPokePoints);
    localStorage.setItem('pokePoints', newPokePoints.toString());
  };
  const sectionRefs = {
    description: useRef(null),
    typeAdvantages: useRef(null),
    news: useRef(null),
    youtubeChannels: useRef(null),
    fanspace: useRef(null),
    guessThatPokemon: useRef(null),
    pokedex: useRef(null),
    shop: useRef(null),
    wardrobe: useRef(null)
  };
  const scrollToSection = section => {
    setActiveSection(section);
    sectionRefs[section].current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <ThemeProvider data-id="element-0">
      <div className="relative min-h-screen w-full bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-white overflow-x-hidden transition-colors duration-300" data-id="element-1">
        <AnimatedBackground data-id="element-2" />
        <div className="relative z-10" data-id="element-3">
          <Header activeSection={activeSection} onNavigate={scrollToSection} data-id="element-4" />
          <PokePoints points={pokePoints} data-id="element-5" />
          <main className="container mx-auto px-4 py-8 max-w-5xl" data-id="element-6">
            <div ref={sectionRefs.description} data-id="element-7">
              <Description data-id="element-8" />
            </div>
            <div ref={sectionRefs.typeAdvantages} className="mt-12" data-id="element-9">
              <TypeAdvantages data-id="element-10" />
            </div>
            <div ref={sectionRefs.news} className="mt-12" data-id="element-11">
              <NewsUpdates data-id="element-12" />
            </div>
            <div ref={sectionRefs.youtubeChannels} className="mt-12" data-id="element-13">
              <YouTubeChannels data-id="element-14" />
            </div>
            <div ref={sectionRefs.fanspace} className="mt-12" data-id="element-15">
              <Fanspace data-id="element-16" />
            </div>
            <div ref={sectionRefs.guessThatPokemon} className="mt-12" data-id="element-17">
              <GuessThatPokemon setPokedexVisibility={setIsPokedexVisible} data-id="element-18" />
            </div>
            <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-19">
              <div ref={sectionRefs.shop} data-id="element-20">
                <Shop pokePoints={pokePoints} onPurchase={handlePurchase} data-id="element-21" />
              </div>
              <div ref={sectionRefs.wardrobe} data-id="element-22">
                <Wardrobe data-id="element-23" />
              </div>
            </div>
            {isPokedexVisible && <div ref={sectionRefs.pokedex} className="mt-12 mb-16" data-id="element-24">
                <Pokedex data-id="element-25" />
              </div>}
          </main>
        </div>
        <div className="fixed bottom-6 right-6 z-30" data-id="element-26">
          <ThemeToggle data-id="element-27" />
        </div>
      </div>
    </ThemeProvider>;
}